// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import App from "./App";
import router from "./router";
import qs from "qs";
import axios from "axios"; //引入axios
import VueAxios from "vue-axios";
import "element-ui/lib/theme-chalk/index.css";
import cookie from "js-cookie";
import "babel-polyfill";
import { host, imgHost } from "../src/api/config";
// import moment from 'moment/moment'
// import VueCookies from 'vue-cookies'
axios.defaults.withCredentials = true; //允许axios请求携带cookie等凭证

// Vue.prototype.$axios = axios;//把axios挂载到vue上
// Vue.use(moment)
Vue.use(ElementUI);

// 全局挂载http请求
import api from "./api/compose";
Vue.prototype.$api = api;
// 全局图片前缀imgHost
// Vue.prototype.$img = 'https://nongji-img.ahnydsj.com/app2/img-upload/';
Vue.prototype.$img = imgHost;

Vue.use(VueAxios, axios);
Vue.prototype.$axios = axios.create({
  baseURL: host,
  //请求前处理数据
  transformRequest: [
    function(data) {
      // console.log(typeof(data));
      data = qs.stringify(data);
      return data;
    }
  ],
  //请求等待超时时间则中断
  timeout: 1500,
  // 请求后的data处理
  transformResponse: [
    function(data) {
      // if (JSON.parse(data).respCode == 3) {
      //       // this.$message.error('token过期')
      //       console.log(31313);
      //       Element.MessageBox.confirm('您的登陆已失效，请重新登陆!')
      //         .then(_ => {
      //           cookie.remove("Flag",{path:''});
      //           cookie.remove("user",{path:''});
      //           sessionStorage.removeItem("Flag")
      //           sessionStorage.removeItem("user")
      //           // router.replace({
      //           //     path: '/login' // 到登录页重新获取token
      //           // })
      //           location.reload()
      //         })
      //     }
      return data;
    }
  ]
});
router.beforeEach((to, from, next) => {
  //获取用户登录成功后储存的登录标志
  let getFlag = sessionStorage.getItem("Flag");
  let getFlag2 = cookie.get("Flag");

  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 路由发生变化改变description和keyword
  if (to.meta.content) {
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", to.meta.content.keywords);
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", to.meta.content.description);
  }

  //如果登录标志存在且为isLogin，即用户已登录
  if (getFlag === "isLogin" || getFlag2 === "isLogin") {
    //设置vuex登录状态为已登录
    // store.state.isLogin = true
    next();
    // //如果已登录，还想想进入登录注册界面，则定向回首页
    // // if (!to.meta.isLogin) {
    // //   //elmentUi友好提示
    // //   // this.$message({
    // //   //   message: "请先登录",
    // //   //   type: "warning"
    // //   // });
    //   next({
    //     // path: '/home'
    //   })
    // }
    //如果登录标志不存在，即未登录
  } else {
    //用户想进入需要登录的页面，则定向回登录界面
    if (to.meta.isLogin) {
      //elmentUi友好提示
      // this.$message({
      //   message: "登录成功!即将前往首页",
      //   type: "success"
      // });
      next({
        path: "/login"
      });
      //用户进入无需登录的界面，则跳转继续
    } else {
      next();
    }
  }
});
router.afterEach(route => {
  window.scroll(0, 0);
});

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js